export const AUTOPILOT_MODULE_LABELS = {
  reclamos: "Reclamos",
  correo: "Correo",
  gastos: "Gastos",
  cobranzas: "Cobranzas",
  conciliacion: "Conciliación",
  liquidacion: "Liquidación",
  liquidaciones: "Liquidación",
};

const MODULE_ALIASES = {
  liquidacion: "liquidaciones",
  liquidaciones: "liquidaciones",
};

export const normalizeAutopilotModule = (module) => {
  const raw = String(module || "").trim().toLowerCase();
  if (!raw) return "";
  return MODULE_ALIASES[raw] || raw;
};

export const getAutopilotModuleQueryParam = (module) => {
  const normalized = normalizeAutopilotModule(module);
  if (!normalized) return "";
  return normalized === "liquidaciones" ? "liquidacion" : normalized;
};

export const getAutopilotModuleLabel = (module) => {
  const normalized = normalizeAutopilotModule(module);
  return AUTOPILOT_MODULE_LABELS[normalized] || AUTOPILOT_MODULE_LABELS[module] || "Autopilot";
};

export const buildAutopilotDashboardUrl = (module) => {
  const queryModule = getAutopilotModuleQueryParam(module);
  return queryModule ? `/panel/autopilot?module=${queryModule}` : "/panel/autopilot";
};

export const buildAutopilotConfigUrl = (module) => {
  const queryModule = getAutopilotModuleQueryParam(module);
  return queryModule ? `/panel/autopilot/configuracion?module=${queryModule}` : "/panel/autopilot/configuracion";
};

export const getAutopilotPendingCount = (overview) =>
  (overview?.suggested_count || 0) +
  (overview?.pending_approval_count || 0) +
  (overview?.risk_count || 0);

export const getAutopilotModuleHealth = (overview) => {
  if ((overview?.risk_count || 0) > 0) {
    return { colorScheme: "red", label: "Riesgos abiertos" };
  }
  if ((overview?.pending_approval_count || 0) > 0) {
    return { colorScheme: "orange", label: "Pendiente de aprobación" };
  }
  if ((overview?.suggested_count || 0) > 0) {
    return { colorScheme: "blue", label: "Sugerencias activas" };
  }
  return { colorScheme: "green", label: "Sin pendientes críticos" };
};
